function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.769,
  y1: 0.835,
  x2: 0.177,
  y2: 0.205,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#004683",
  stopOpacity: 0.82
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_6",
  "data-name": "Layer 6",
  transform: "translate(-55.436 -537.639)",
  opacity: 0.9
}, React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10",
  transform: "translate(1 1)"
}, React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M100,0A100,100,0,1,1,0,100,100,100,0,0,1,100,0Z",
  transform: "translate(54.436 536.639)",
  fill: "url(#linear-gradient)"
}), React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M82.944,616.912c0-11.488,14.773-49.19,65.317-54.748",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 9
}), React.createElement("rect", {
  id: "Rectangle_4",
  "data-name": "Rectangle 4",
  width: 50,
  height: 50,
  transform: "translate(129.884 612.593)",
  strokeWidth: 7.5,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 21.333,
  height: 21.333,
  transform: "translate(144.218 626.926)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_2",
  "data-name": "Line 2",
  y1: 9.593,
  transform: "translate(144.218 601.741)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_3",
  "data-name": "Line 3",
  y1: 9.593,
  transform: "translate(165.551 601.741)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_4",
  "data-name": "Line 4",
  x2: 10.647,
  transform: "translate(179.884 626.926)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_5",
  "data-name": "Line 5",
  x2: 10.647,
  transform: "translate(179.884 648.259)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_6",
  "data-name": "Line 6",
  x1: 10.506,
  transform: "translate(119.378 648.259)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_7",
  "data-name": "Line 7",
  x1: 8.5,
  transform: "translate(119.378 626.926)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_8",
  "data-name": "Line 8",
  y2: 10.667,
  transform: "translate(144.218 662.593)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), React.createElement("line", {
  id: "Line_9",
  "data-name": "Line 9",
  y2: 10.667,
  transform: "translate(165.551 662.593)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
})));

var SvgHardware = function SvgHardware(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHardware, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hardware.6bdf135f.svg";
export { ForwardRef as ReactComponent };